var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg5(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 2048 1536",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 1400H2048V1536H0Z",
    fill: "#101010"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#101010",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 1380,
    x2: 8,
    y2: 1320
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 1380,
    x2: 28,
    y2: 1320
  }), /*#__PURE__*/React.createElement("line", {
    x1: 40,
    y1: 1380,
    x2: 48,
    y2: 1320
  }), /*#__PURE__*/React.createElement("line", {
    x1: 60,
    y1: 1380,
    x2: 68,
    y2: 1320
  }), /*#__PURE__*/React.createElement("line", {
    x1: 80,
    y1: 1380,
    x2: 88,
    y2: 1320
  }), /*#__PURE__*/React.createElement("line", {
    x1: 100,
    y1: 1380,
    x2: 108,
    y2: 1320
  }), /*#__PURE__*/React.createElement("line", {
    x1: 120,
    y1: 1380,
    x2: 128,
    y2: 1320
  }), /*#__PURE__*/React.createElement("line", {
    x1: 140,
    y1: 1380,
    x2: 148,
    y2: 1320
  }), /*#__PURE__*/React.createElement("line", {
    x1: 160,
    y1: 1380,
    x2: 168,
    y2: 1320
  }), /*#__PURE__*/React.createElement("line", {
    x1: 180,
    y1: 1380,
    x2: 188,
    y2: 1320
  }), /*#__PURE__*/React.createElement("line", {
    x1: 200,
    y1: 1380,
    x2: 208,
    y2: 1320
  }), /*#__PURE__*/React.createElement("line", {
    x1: 220,
    y1: 1380,
    x2: 228,
    y2: 1320
  }), /*#__PURE__*/React.createElement("line", {
    x1: 240,
    y1: 1380,
    x2: 248,
    y2: 1320
  }), /*#__PURE__*/React.createElement("line", {
    x1: 260,
    y1: 1380,
    x2: 268,
    y2: 1320
  }), /*#__PURE__*/React.createElement("line", {
    x1: 280,
    y1: 1380,
    x2: 288,
    y2: 1320
  }), /*#__PURE__*/React.createElement("line", {
    x1: 300,
    y1: 1380,
    x2: 308,
    y2: 1320
  }), /*#__PURE__*/React.createElement("line", {
    x1: 320,
    y1: 1380,
    x2: 328,
    y2: 1320
  }), /*#__PURE__*/React.createElement("line", {
    x1: 340,
    y1: 1380,
    x2: 348,
    y2: 1320
  }), /*#__PURE__*/React.createElement("line", {
    x1: 360,
    y1: 1380,
    x2: 368,
    y2: 1320
  }), /*#__PURE__*/React.createElement("line", {
    x1: 380,
    y1: 1380,
    x2: 388,
    y2: 1320
  }), /*#__PURE__*/React.createElement("line", {
    x1: 400,
    y1: 1380,
    x2: 408,
    y2: 1320
  }), /*#__PURE__*/React.createElement("line", {
    x1: 420,
    y1: 1380,
    x2: 428,
    y2: 1320
  }), /*#__PURE__*/React.createElement("line", {
    x1: 440,
    y1: 1380,
    x2: 448,
    y2: 1320
  }), /*#__PURE__*/React.createElement("line", {
    x1: 460,
    y1: 1380,
    x2: 468,
    y2: 1320
  }), /*#__PURE__*/React.createElement("line", {
    x1: 480,
    y1: 1380,
    x2: 488,
    y2: 1320
  }), /*#__PURE__*/React.createElement("line", {
    x1: 500,
    y1: 1380,
    x2: 508,
    y2: 1320
  }), /*#__PURE__*/React.createElement("line", {
    x1: 520,
    y1: 1380,
    x2: 528,
    y2: 1320
  }), /*#__PURE__*/React.createElement("line", {
    x1: 540,
    y1: 1380,
    x2: 548,
    y2: 1320
  }), /*#__PURE__*/React.createElement("line", {
    x1: 560,
    y1: 1380,
    x2: 568,
    y2: 1320
  }), /*#__PURE__*/React.createElement("line", {
    x1: 580,
    y1: 1380,
    x2: 588,
    y2: 1320
  }), /*#__PURE__*/React.createElement("line", {
    x1: 600,
    y1: 1380,
    x2: 608,
    y2: 1320
  }), /*#__PURE__*/React.createElement("line", {
    x1: 620,
    y1: 1380,
    x2: 628,
    y2: 1320
  }), /*#__PURE__*/React.createElement("line", {
    x1: 640,
    y1: 1380,
    x2: 648,
    y2: 1320
  }), /*#__PURE__*/React.createElement("line", {
    x1: 660,
    y1: 1380,
    x2: 668,
    y2: 1320
  }), /*#__PURE__*/React.createElement("line", {
    x1: 680,
    y1: 1380,
    x2: 688,
    y2: 1320
  }), /*#__PURE__*/React.createElement("line", {
    x1: 700,
    y1: 1380,
    x2: 708,
    y2: 1320
  }), /*#__PURE__*/React.createElement("line", {
    x1: 720,
    y1: 1380,
    x2: 728,
    y2: 1320
  }), /*#__PURE__*/React.createElement("line", {
    x1: 740,
    y1: 1380,
    x2: 748,
    y2: 1320
  }), /*#__PURE__*/React.createElement("line", {
    x1: 760,
    y1: 1380,
    x2: 768,
    y2: 1320
  }), /*#__PURE__*/React.createElement("line", {
    x1: 780,
    y1: 1380,
    x2: 788,
    y2: 1320
  }), /*#__PURE__*/React.createElement("line", {
    x1: 800,
    y1: 1380,
    x2: 808,
    y2: 1320
  }), /*#__PURE__*/React.createElement("line", {
    x1: 820,
    y1: 1380,
    x2: 828,
    y2: 1320
  }), /*#__PURE__*/React.createElement("line", {
    x1: 840,
    y1: 1380,
    x2: 848,
    y2: 1320
  }), /*#__PURE__*/React.createElement("line", {
    x1: 860,
    y1: 1380,
    x2: 868,
    y2: 1320
  }), /*#__PURE__*/React.createElement("line", {
    x1: 880,
    y1: 1380,
    x2: 888,
    y2: 1320
  }), /*#__PURE__*/React.createElement("line", {
    x1: 900,
    y1: 1380,
    x2: 908,
    y2: 1320
  }), /*#__PURE__*/React.createElement("line", {
    x1: 920,
    y1: 1380,
    x2: 928,
    y2: 1320
  }), /*#__PURE__*/React.createElement("line", {
    x1: 940,
    y1: 1380,
    x2: 948,
    y2: 1320
  }), /*#__PURE__*/React.createElement("line", {
    x1: 960,
    y1: 1380,
    x2: 968,
    y2: 1320
  }), /*#__PURE__*/React.createElement("line", {
    x1: 980,
    y1: 1380,
    x2: 988,
    y2: 1320
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1000,
    y1: 1380,
    x2: 1008,
    y2: 1320
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1020,
    y1: 1380,
    x2: 1028,
    y2: 1320
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1040,
    y1: 1380,
    x2: 1048,
    y2: 1320
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1060,
    y1: 1380,
    x2: 1068,
    y2: 1320
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1080,
    y1: 1380,
    x2: 1088,
    y2: 1320
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1100,
    y1: 1380,
    x2: 1108,
    y2: 1320
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1120,
    y1: 1380,
    x2: 1128,
    y2: 1320
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1140,
    y1: 1380,
    x2: 1148,
    y2: 1320
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1160,
    y1: 1380,
    x2: 1168,
    y2: 1320
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1180,
    y1: 1380,
    x2: 1188,
    y2: 1320
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1200,
    y1: 1380,
    x2: 1208,
    y2: 1320
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1220,
    y1: 1380,
    x2: 1228,
    y2: 1320
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1240,
    y1: 1380,
    x2: 1248,
    y2: 1320
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1260,
    y1: 1380,
    x2: 1268,
    y2: 1320
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1280,
    y1: 1380,
    x2: 1288,
    y2: 1320
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1300,
    y1: 1380,
    x2: 1308,
    y2: 1320
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1320,
    y1: 1380,
    x2: 1328,
    y2: 1320
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1340,
    y1: 1380,
    x2: 1348,
    y2: 1320
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1360,
    y1: 1380,
    x2: 1368,
    y2: 1320
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1380,
    y1: 1380,
    x2: 1388,
    y2: 1320
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1400,
    y1: 1380,
    x2: 1408,
    y2: 1320
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1420,
    y1: 1380,
    x2: 1428,
    y2: 1320
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1440,
    y1: 1380,
    x2: 1448,
    y2: 1320
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1460,
    y1: 1380,
    x2: 1468,
    y2: 1320
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1480,
    y1: 1380,
    x2: 1488,
    y2: 1320
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1500,
    y1: 1380,
    x2: 1508,
    y2: 1320
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1520,
    y1: 1380,
    x2: 1528,
    y2: 1320
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1540,
    y1: 1380,
    x2: 1548,
    y2: 1320
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1560,
    y1: 1380,
    x2: 1568,
    y2: 1320
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1580,
    y1: 1380,
    x2: 1588,
    y2: 1320
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1600,
    y1: 1380,
    x2: 1608,
    y2: 1320
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1620,
    y1: 1380,
    x2: 1628,
    y2: 1320
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1640,
    y1: 1380,
    x2: 1648,
    y2: 1320
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1660,
    y1: 1380,
    x2: 1668,
    y2: 1320
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1680,
    y1: 1380,
    x2: 1688,
    y2: 1320
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1700,
    y1: 1380,
    x2: 1708,
    y2: 1320
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1720,
    y1: 1380,
    x2: 1728,
    y2: 1320
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1740,
    y1: 1380,
    x2: 1748,
    y2: 1320
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1760,
    y1: 1380,
    x2: 1768,
    y2: 1320
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1780,
    y1: 1380,
    x2: 1788,
    y2: 1320
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1800,
    y1: 1380,
    x2: 1808,
    y2: 1320
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1820,
    y1: 1380,
    x2: 1828,
    y2: 1320
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1840,
    y1: 1380,
    x2: 1848,
    y2: 1320
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1860,
    y1: 1380,
    x2: 1868,
    y2: 1320
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1880,
    y1: 1380,
    x2: 1888,
    y2: 1320
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1900,
    y1: 1380,
    x2: 1908,
    y2: 1320
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1920,
    y1: 1380,
    x2: 1928,
    y2: 1320
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1940,
    y1: 1380,
    x2: 1948,
    y2: 1320
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1960,
    y1: 1380,
    x2: 1968,
    y2: 1320
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1980,
    y1: 1380,
    x2: 1988,
    y2: 1320
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2000,
    y1: 1380,
    x2: 2008,
    y2: 1320
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2020,
    y1: 1380,
    x2: 2028,
    y2: 1320
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2040,
    y1: 1380,
    x2: 2048,
    y2: 1320
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg5);
export default __webpack_public_path__ + "static/media/5.93708dbdc6b1826904779d0b39e018ff.svg";
export { ForwardRef as ReactComponent };